import Vue from 'vue'
import store from "../store"
import u from "@/mixins/utils";
const utils=u.methods;

export async function check_mun(mun) {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT+"public/check?nonce="+mun,
        type: "GET",
        show_error: true,
        retry: 1000,
    };
    return await utils.utils_async_ajax(config);
}


export async function get_app_configs() {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT+"public/configs",
        type: "GET",
        show_error: true,
        retry: 1000,
    };
    return await utils.utils_async_ajax(config);
}